<template>
  <LayoutDefault>
    <div
      v-if="loading"
      style="
        display: flex;
        height: 500px;
        justify-content: center;
        align-items: center;
      "
    >
      <Spinner />
    </div>
    <div ref="MySreen" class="MyScreen">
      <div class="row-container" :class="rowContainerClass">
        <div class="logs-container" :style="showLogsStyle">
          <LogList 
            ref="logs" 
            @close="closeLogListHandler" 
            :videoCallRoom="videoCallRoom" 
          />
        </div>
        <div class="superIframe">
          <vue-jitsi-meet
            ref="jitsiRef"
            :domain="VIDEOCALL_DOMAIN"
            :options="jitsiOptions"
            :style="{ opacity: loading ? 0 : 1 }"
          ></vue-jitsi-meet>
        </div>
      </div>
      <Bar 
        ref="bar" 
        :videoCallRoom="videoCallRoom" 
        @closeLogs="closeLogs"
        @showLogs="showLogs"
        @tokensSended="handleTokensSended"
        @request-fullscreen="handleFullScreen"
        @exit-fullscreen="handleExitFullScreen"
        @endCall="endCallHandler"
      />
    </div>
  </LayoutDefault>
</template>
<script>
import LayoutDefault from "../layouts/LayoutDefault";
import { JitsiMeet } from "@mycure/vue-jitsi-meet";
import Spinner from "../components/Spinner";
import resources from "../resources";
import Echo from "laravel-echo";
import Bar from "../components/VideoChat/Bar";
import LogList from "../components/VideoChat/LogList";

const TokensAudio = new Audio("/audio/coins-falling.mp3");

const VIDEOCALL_DOMAIN = process.env.VUE_APP_VIDEOCALL_DOMAIN;

export default {
  components: {
    LayoutDefault,
    VueJitsiMeet: JitsiMeet,
    Spinner,
    Bar,
    LogList,
  },
  data() {
    return {
      loading: true,
      videoCallRoom: {},
      showLogsStyle: {
        transform: "translateX(-100%)",
      },
      rowContainerClass: {
        fullscreen: false,
      },
      user: this.$auth.user(),
      VIDEOCALL_DOMAIN
    };
  },
  computed: {
    jitsiOptions() {
      return {
        roomName: this.$route.params.hash,
        noSSL: false,
        userInfo: {
          displayName: this.$auth.user().username,
        },
        configOverwrite: {
          enableNoisyMicDetection: false,
          disableDeepLinking: true,
          disablePolls: true,
          speakerStats: {
            disabled: false,
          },
          securityUi: {
            hideLobbyButton: true,
          },
          requireDisplayName: false,
          enableWelcomePage: false,
          disableProfile: true,
          prejoinConfig: {
            //     // When 'true', it shows an intermediate page before joining, where the user can configure their devices.
            //     // This replaces `prejoinPageEnabled`.
            enabled: true,
            //     // Hides the participant name editing field in the prejoin screen.
            //     // If requireDisplayName is also set as true, a name should still be provided through
            //     // either the jwt or the userInfo from the iframe api init object in order for this to have an effect.
            hideDisplayName: true,
            //     // List of buttons to hide from the extra join options dropdown.
            //     hideExtraJoinButtons: ['no-audio', 'by-phone'],
          },
          readOnlyName: false,
          disableInviteFunctions: true,
          // - if `toolbarButtons` is undefined, we fallback to enabling all buttons on the UI
          toolbarButtons: [
            "camera",
            "chat",
            //    'closedcaptions',
            //    'desktop',
            //    'download',
            //    'embedmeeting',
            //    'etherpad',
            //    'feedback',
            //    'filmstrip',
            //    'fullscreen',
            "hangup",
            //    'help',
            //    'highlight',
            //    'invite',
            //    'linktosalesforce',
            //    'livestreaming',
            "microphone",
            //    'noisesuppression',
            //    'participants-pane',
            //    'profile',
            //    'raisehand',
            //    'recording',
            //    'security',
            //    'select-background',
            //    'settings',
            //    'shareaudio',
            //    'sharedvideo',
            //    'shortcuts',
            //    'stats',
            //    'tileview',
            //    'toggle-camera',
            //    'videoquality',
            //    'whiteboard',
          ],
        },
        interfaceConfigOverwrite: {
          SHOW_JITSI_WATERMARK: false,
          SHOW_WATERMARK_FOR_GUESTS: false,
          SHOW_CHROME_EXTENSION_BANNER: false,
        },
        onload: this.onIFrameLoad,
      };
    },
    
  },
  methods: {
    endCallHandler() {
      this.$refs.jitsiRef.executeCommand("endConference");
    },
    closeLogListHandler() {
      this.closeLogs();
      this.$refs.bar.closeLogListHandler();
    },
    closeLogs() {
      this.showLogsStyle = {
        transform: "translateX(-100%)",
      };
    },
    showLogs() {
      this.showLogsStyle = {
        transform: "translateX(0%)",
      };
    },
    handleFullScreen() {
      this.$refs.MySreen.requestFullscreen();
      this.rowContainerClass.fullscreen = true;
    },
    handleExitFullScreen() {
      document.exitFullscreen();
      this.rowContainerClass.fullscreen = false;
    },
    handleTokensSended(quantity) {
      const short_message = this.$t("videocall.messages.short_sent_tokens", { quantity: quantity });

      this.$refs.logs.appendLog({
        emisor: this.user.username,
        description: short_message,
      });
    },
    onIFrameLoad() {
      this.loading = false;
      this.$refs.jitsiRef.addEventListener(
        "participantJoined",
        this.onParticipantJoined
      );
      const iframe = document.getElementById("jitsiConferenceFrame0");
      const overlay = this.$refs.overlay;
      //overlay.style.display = 'block';

      iframe.addEventListener("fullscreenchange", () => {
        if (document.fullscreenElement === iframe) {
          // If the iframe is in full-screen mode
          overlay.style.display = "block";
          iframe.style.height = "100%";
          iframe.exitFullscreen();
        } else {
          // If the iframe is not in full-screen mode
          overlay.style.display = "none";
        }
      });
    },
    onParticipantJoined(e) {
      this.startCall();
    },
    getVideoCallRoomData() {
      resources.videoCallRoom
        .get({ id: this.$route.params.hash })
        .then((response) => {
          this.videoCallRoom = response.data;

          //this.videoCallRoom.started_at = Date.now();
        })
        .catch((error) => {
          if (error.status == 422) {
            // Here maybe I should redirect the user. or show an error message.
            console.log("VideoCallRoom does not exist");
            return;
          }
        });
    },
    startCall() {
      resources.videoCallRoom
        .storeAt({ id: this.$route.params.hash + "/start" })
        .then((response) => {
          if (response.status == 200 && response.data.started_at !== null) {
            this.videoCallRoom.started_at = response.data.started_at;
          }
        })
        .catch((error) => {
          if (error.status == 422) {
            // Here maybe I should redirect the user. or show an error message.
            console.log("VideoCallRoom does not exist");
            return;
          }
          console.log("error", error);
        });
    },
  },
  mounted() {
    window.Echo = new Echo({
      broadcaster: process.env.VUE_APP_ECHO_BROADCASTER,
      key: process.env.VUE_APP_ECHO_KEY,
      cluster: process.env.VUE_APP_ECHO_CLUSTER,
      forceTLS: false,
      authEndpoint: process.env.VUE_APP_ECHO_AUTH,
      wsHost: process.env.VUE_APP_ECHO_WSHOST,
      wsPort: process.env.VUE_APP_ECHO_WSPORT,
      wssPort: process.env.VUE_APP_ECHO_WSPORT,
      disableStats: false,
      auth: {
        headers: {
          Authorization: "Bearer " + this.$auth.token(),
          Accept: "application/json",
        },
      },
    });
    window.Echo.private(`VideoCallRoom.${this.$route.params.hash}`)
      .listen("VideoCallRoomStarted", (e) => {
        this.videoCallRoom.started_at = e.room.started_at;
      })
      .listen("VideoCallRoomUnlimited", (e) => {
        this.videoCallRoom.is_unlimited = e.room.is_unlimited;
      })
      .listen("VideoCallRoomExtraMinuteBought", (e) => {
        this.videoCallRoom.extra_minutes_bought = e.room.extra_minutes_bought;
      })
      .listen("VideoCallRoomTokensReceived", (e) => {
        const username = e.token_transaction.username;
        const quantity = e.token_transaction.quantity;

        const message = this.$t("videocall.messages.received_tokens", { username, quantity });

        this.$toast.success(message, {
          duration: 5000,
          position: "top-right",
        });

        const short_message = this.$t("videocall.messages.short_received_tokens", { quantity: quantity });

        this.$refs.logs.appendLog({
          emisor: username,
          description: short_message,
        });

        TokensAudio.play();
      });

    this.getVideoCallRoomData();
  },
};
</script>

<style scoped>
.MyScreen {
  display: flex;
  flex-direction: column;
}

#overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  text-align: center;
  display: none;
}

.superIframe {
  /*position: fixed;*/
  min-height: 500px; 
  height: 500px;

  top: 0;
  left: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  text-align: center;

  flex-grow: 1;
}

.row-container {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  position: relative;

  &.fullscreen {
    div {
      height: 100% !important;
    }
  }
}

.logs-container {
  height: 500px;
  position: absolute;

  background-color: #131519;

  /* transform: translateX(-100%); */
  overflow: hidden;
  transition: width 0.5s ease-in-out;
}
</style>

<style lang="scss">
div#layout_wrapper > div.sideToolbarContainer#sideToolbarContainer {
  background-color: #13151920;
}
</style>
